import type { FC } from 'react';

import { ArrowUpRightIcon, GlobeAltIcon } from '@heroicons/react/24/outline';
import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

const WEB_PROTOCOLS = new Set(['http:', 'https:']);

const isWebUrl = (url: string): boolean => {
  try {
    return WEB_PROTOCOLS.has(new URL(url).protocol);
  } catch {
    return false;
  }
};

export const NavSubtitle: FC = () => {
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  const subtitle = layoutData?.community?.nav_subtitle;

  if (!subtitle?.text) return null;

  if (subtitle.type === 'tagline') {
    return (
      <span className="max-w-full truncate text-xs font-normal leading-4 text-community-text-on-bg/60">
        {subtitle.text}
      </span>
    );
  }

  if (!subtitle.url || !isWebUrl(subtitle.url)) return null;

  return (
    <a
      href={subtitle.url}
      target="_blank"
      rel="noopener noreferrer"
      title={subtitle.url}
      className="box-border inline-flex h-[22px] max-w-full items-center gap-1 rounded-full border border-community-text-on-bg/50 px-2 text-xs font-medium leading-4 text-community-text-on-bg/80 no-underline transition-colors hover:bg-community-text-on-bg/[0.08]"
    >
      <GlobeAltIcon className="size-3 shrink-0" strokeWidth={1.8} aria-hidden="true" />
      <span className="min-w-0 truncate">{subtitle.text}</span>
      <ArrowUpRightIcon className="size-2.5 shrink-0" strokeWidth={2.2} aria-hidden="true" />
    </a>
  );
};
